import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { paragraphMicro, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.button `
  ${ButtonReset}

  display: grid;
  border: 1px solid ${brand.greyMid};
  gap: 20px;
  grid-template-columns: 85px 1fr;
  padding: 12px;
  text-align: left;
  ${transition('border-color')};
  width: 100%;

  &[data-active='true'] {
    border: 3px solid ${brand.greenBright};
  }

  &[data-danger='true'] {
    border-color: ${brand.validation.invalid};
  }

  button&.focus-ring {
    outline: auto;
    outline-offset: 3px;
  }

  button&:hover {
    border: 3px solid ${brand.greenBright};
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(85, 85)}

  display: block;
  background: ${brand.beige};
`;
const Image = styled.img `
  ${imageCoverContainer()}
`;
const ContentWrapper = styled.div `
  display: block;
`;
const Title = styled.h3 `
  ${paragraphSmall}

  display: block;
  margin: 0;
`;
const Count = styled.span `
  ${paragraphSmall}

  display: block;
  margin: 0;
  opacity: 0.5;
`;
const Unpin = styled.span `
  ${paragraphMicro};

  display: block;
  margin: ${fluid(4, 6)} 0 0;
  opacity: 0.7;
`;
const PinboardPreviewStyles = {
    Container,
    ContentWrapper,
    Count,
    Image,
    ImageWrapper,
    Title,
    Unpin,
};
export default PinboardPreviewStyles;
